import styled from "@emotion/styled";
import { Link as RebassLink } from "rebass";
import { COLORS } from "ui-components/theme";

const Link = styled(RebassLink)`
  cursor: pointer;
  text-decoration: none;
`;

const StyledLink = styled(RebassLink)`
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  color: ${({
    disabled,
    color = `${COLORS.purple[7]}`,
    disabledColor = "#c7c7c7cc"
  }) => (disabled ? disabledColor : color)};
`;
StyledLink.defaultProps = {
  cursor: "pointer",
  padding: "12px",
  color: `${COLORS.purple[7]}`,
  fontWeight: 700
};

export { StyledLink };
export default Link;
